import { graphqlOperation } from 'aws-amplify';
import {
  bulkDeleteUser as bulkDeleteUserMutation,
  createUser as createUserMutation,
  deleteUser as deleteUserMutation,
  updateUser,
  createUserWest,
} from '../../graphql/mutations';
import { graphql } from '../../utils/api';

const usersStore = {
  state: {
    users: [],
  },
  reducers: {
    SET_USERS(state, payload) {
      return {
        ...state,
        users: payload,
      };
    },
  },
  effects: (dispatch) => ({
    setUsers(payload) {
      dispatch.users.SET_USERS(payload);
    },
    addUser(user, state) {
      dispatch.users.SET_USERS([...state.users.users, user]);
    },

    async createUser(payload, rootState) {
      const bussinessId = rootState.bussiness?.bussiness?.id;
      const {
        userId,
        firstName,
        middleName,
        lastName,
        email,
        phoneNumber,
        userRole,
        password,
        storeIds,
        ...rest
      } = payload.values;
      const mutationInput = {
        userId,
        firstName,
        middleName,
        lastName,
        email,
        phoneNumber,
        userRole,
        password,
        merchantAccountId: bussinessId,
        storeIds,
        ...rest,
      };
      await graphql(
        graphqlOperation(createUserMutation, {
          input: mutationInput,
        }),
      );

      graphql(
        graphqlOperation(createUserWest, {
          input: {
            email,
            firstName,
            middleName,
            lastName,
            phoneNumber,
            password,
            username: userId,
          },
        }),
      );
    },

    async updateUser(payload, rootState) {
      const bussinessId = rootState.bussiness?.bussiness?.id;
      const {
        userId,
        firstName,
        middleName,
        lastName,
        email,
        phoneNumber,
        role,
        ...rest
      } = payload.values;
      const mutationInput = {
        userId,
        firstName,
        middleName,
        lastName,
        email,
        phoneNumber,
        role,
        merchantAccountId: bussinessId,
        ...rest,
      };
      await graphql(
        graphqlOperation(updateUser, {
          input: mutationInput,
        }),
      );
    },

    async deleteUser(payload, rootState) {
      const { userId } = payload;

      await graphql(
        graphqlOperation(deleteUserMutation, {
          input: { userId: payload },
        }),
      );

      const newUsers = [];
      rootState.users.users.map((userItem) => {
        if (userItem.userId !== userId) {
          newUsers.push(userItem);
        }
      });
      dispatch.users.SET_USERS(newUsers);
    },

    async bulkDeleteUser(payload) {
      const mutationInput = { userIds: payload };
      const addRes = await graphql(
        graphqlOperation(bulkDeleteUserMutation, {
          input: mutationInput,
        }),
      );
      return addRes;
    },
  }),
};

export default usersStore;
